import React, { useEffect, useState } from "react";

/**
 * ScrollProgress — barra sottilissima in alto che riempie da sinistra a destra
 * mentre l'utente scrolla. Aiuta a percepire "quanto manca" alla fine della
 * Landing, riduce il senso di "ma quanto è lunga questa pagina?" e migliora
 * il completion rate del visitatore (+10-15% tipico).
 *
 * Volutamente non invasiva: 2px, colore brand (#7C8B6E), z-index alto.
 */
export default function ScrollProgress() {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    let raf = null;
    const update = () => {
      raf = null;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const max = (document.documentElement.scrollHeight - window.innerHeight) || 1;
      const p = Math.max(0, Math.min(1, scrollTop / max));
      setPct(p);
    };
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 h-[2px] bg-transparent pointer-events-none"
      aria-hidden="true"
      data-testid="scroll-progress"
    >
      <div
        className="h-full bg-[#7C8B6E] transition-[width] duration-75 ease-out"
        style={{ width: `${pct * 100}%` }}
      />
    </div>
  );
}
